var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollapseSmall = function SvgCollapseSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.939941 10.3927L1.88661 11.3327L3.99994 9.21935L6.11328 11.3327L7.05327 10.3927L3.99994 7.33268L0.939941 10.3927ZM7.05994 1.60602L6.11328 0.666016L3.99994 2.77935L1.88661 0.666016L0.939941 1.60602L3.99994 4.66602L7.05994 1.60602Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseSmall);
export { ForwardRef as ReactComponent };